module.exports = __webpack_public_path__ + "img/q8.595cc73f.png";